module.exports = __webpack_public_path__ + "img/A1.2.5.1.b5b82a81.png";